import { defineStore } from 'pinia'

import { IDictState } from '@/store/dict/type.ts'
import ApiDict from '@/apis/dict'
import { isRef } from 'vue'

const useDictStore = defineStore('initDict', {
  state: (): IDictState => ({
    dict_expert_label: [],
    dict_area: [],
    dict_project_process_expert_status: [], // 项目那边用 状态
    dict_sys_obj: {}
  }),

  actions: {
    actionInit() {
      ApiDict.treeExpertLabel().then(res => {
        this.dict_expert_label =
          Array.from(new Set(res?.data?.map((item: any) => item.name))).map(name => {
            return res?.data?.find((item: any) => item.name === name)
          }) ?? []
      })

      ApiDict.treeArea().then(res => {
        this.dict_area = res.data ?? []
      })

      ApiDict.listExportStatus().then(res => {
        this.dict_project_process_expert_status =
          res.data.map((item: any) => {
            const css = item.css.split(',')
            item.bgc = css?.[1] ? `rgb(var(--${css?.[1]}))` : ''
            item.color = css?.[0] ? `rgb(var(--${css?.[0]}))` : ''
            return item
          }) ?? []
      })
    },
    async actionByType(dictType: string) {
      const res = await ApiDict.listDataByType({ dictType, pageNo: 1, pageSize: 100 })
      this.dict_sys_obj[dictType] = res?.data?.list ?? []
    },
    actionResetTableByStatusList(tableList: any) {
      if (isRef(tableList)) {
        if (tableList?.value?.length > 0) {
          tableList.value?.forEach?.(async (item: any) => {
            const res = await ApiDict.listProjectCanUpdateStatus({ childStatus: item.childStatus, projectBloggersId: item.id })
            const list =
              res.data.map((el: any) => {
                const css = el.css.split(',')
                el.bgc = css?.[1] ? `rgb(var(--${css?.[1]}))` : ''
                el.color = css?.[0] ? `rgb(var(--${css?.[0]}))` : ''
                return el
              }) ?? []
            item.statusCurt = this.dict_project_process_expert_status.find(s => s.code == item.childStatus)
            item.statusList = [...list]
          })
        }
      } else {
        if (tableList?.length > 0) {
          tableList?.forEach?.(async (item: any) => {
            const res = await ApiDict.listProjectCanUpdateStatus({ childStatus: item.childStatus, projectBloggersId: item.id })
            const list =
              res.data.map((el: any) => {
                const css = el.css.split(',')
                el.bgc = css?.[1] ? `rgb(var(--${css?.[1]}))` : ''
                el.color = css?.[0] ? `rgb(var(--${css?.[0]}))` : ''
                return el
              }) ?? []
            item.statusCurt = this.dict_project_process_expert_status.find(s => s.code == item.childStatus)
            item.statusList = [...list]
          })
        }
      }
    },
    async actionResetObjectByStatusList(obj: any) {
      if (obj) {
        const res = await ApiDict.listProjectCanUpdateStatus({ childStatus: obj.childStatus, projectBloggersId: obj.id })
        const list =
          res.data.map((el: any) => {
            const css = el.css.split(',')
            el.bgc = css?.[1] ? `rgb(var(--${css?.[1]}))` : ''
            el.color = css?.[0] ? `rgb(var(--${css?.[0]}))` : ''
            return el
          }) ?? []
        obj.statusCurt = this.dict_project_process_expert_status.find(s => s.code == obj.childStatus)
        obj.statusList = [...list]
      }
    }
  }
})

export default useDictStore
